/**
 * Location-based Validation Configuration
 * 
 * This file contains validation rules that differ between locations (UK, USA, etc.).
 * Only fields with location-specific validation rules should be included here.
 * 
 * Structure:
 * - Each field has its own configuration object
 * - Each location (UK, USA, etc.) has its own validation rules
 * - Rules include: regex pattern, min/max length, error messages
 */

import * as regexClass from "../common/regex";
import * as messageClass from "../common/message";

/**
 * Get the current location label from environment variable
 * @returns {string} Location label (e.g., "UK", "USA")
 */
export const getLocationLabel = () => {
  return process.env.REACT_APP_LOCATION_LABEL || "USA";
};

/**
 * Check if current location is UK
 * @returns {boolean}
 */
export const isUK = () => {
  return getLocationLabel() === "UK";
};

/**
 * Zipcode validation configuration
 * UK: Alphanumeric, max 9 characters (e.g., SW1A 1AA, M1 1AA)
 * USA: Numbers with optional hyphen, max 10 characters (e.g., 12345, 12345-6789)
 */
const zipcodeValidationConfig = {
  UK: {
    regex: regexClass.ALPHANUMERIC_ZIPCODE_REGEX,
    maxLength: 9,
    errorMessage: messageClass.NUMBER_ONLY_CLINIC,
    lengthErrorMessage: messageClass.CLINIC_ZIPCODE_VALID,
  },
  USA: {
    regex: regexClass.NUMBERREGEX_WITH_HYPHEN,
    maxLength: 10,
    errorMessage: messageClass.NUMBER_ONLY_CLINIC,
    lengthErrorMessage: messageClass.CLINIC_ZIPCODE_VALID,
  },
};

/**
 * Get zipcode validation config for current location
 * @returns {Object} Validation configuration object
 */
export const getZipcodeValidationConfig = () => {
  const location = getLocationLabel();
  return zipcodeValidationConfig[location] || zipcodeValidationConfig.USA;
};

